export type BmiFromHeightWeightInput = {
  weight?: number | null;
  weightUnit?: string;
  height?: number | null;
  heightUnit?: string;
  feet?: number | null;
  inches?: number | null;
};

/**
 * Calculates BMI from weight and height data (same rules as the patient weightHeight list UI).
 * @returns BMI as a string rounded to 2 decimals, or '' if inputs are incomplete or unsupported.
 */
export const calculateBMI = (data: BmiFromHeightWeightInput): number | null => {
  const { weight, weightUnit, height, heightUnit, feet, inches } = data;

  if (!weight || !weightUnit || !heightUnit) {
    return null;
  }

  if (heightUnit === 'centimeters' && !height) {
    return null;
  }

  if (heightUnit === 'feetIn' && (feet === undefined || inches === undefined)) {
    return null;
  }

  if (weightUnit === 'kilograms' && heightUnit === 'centimeters') {
    const bmi = Math.round((weight * 100) / ((height * height) / 10000)) / 100;
    if (isNaN(bmi) || bmi === Infinity || bmi === -Infinity) {
      return null;
    }
    return bmi;
  } else if (weightUnit === 'lbs' && heightUnit === 'feetIn') {
    const h = feet * 12 + inches;
    const bmi = Math.round((weight / h / h) * 703 * 100) / 100;
    if (isNaN(bmi) || bmi === Infinity || bmi === -Infinity) {
      return null;
    }
    return bmi;
  }

  return null;
};

export const formatHeight = (data: BmiFromHeightWeightInput): string => {
  const { height, heightUnit, feet, inches } = data;

  if (heightUnit === 'centimeters') {
    return (height || '') + ' cm';
  }

  if (heightUnit === 'feetIn') {
    return (feet || '') + 'ft ' + (inches || '') + 'in';
  }

  return '';
};
